import { Component, ErrorHandler, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import swal from 'sweetalert2';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { UserService } from '../../../../shared/user.service';
@Component({
  selector: 'app-networkgrid',
  templateUrl: './networkgrid.component.html',
  styleUrls: ['./networkgrid.component.css']
})
export class NetworkgridComponent implements OnInit {
  title="Network Details";
  dtOptions: any = {};
  NetworkList: any[] = [];
  mode: any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;
  data: any;
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) { }

  ngOnInit() {
    this.GetAllNetwork();
    $(document).ready(function(){
    $('[data-toggle="tooltip"]').tooltip();
  });
       this.dtOptions = {
        dom: 'lBfrtip',
        lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
        scroll: "250px",
        select: true,
        buttons: [
          {
            extend: 'collection',
            text: 'Export',
            className: 'btn btn-radius',
            buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
          },
          { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
        ],
      }
    }

    GetAllNetwork() {
      this.data = this.userService.GetAllNetwork();
      this.data.subscribe((Response: any) => {
        this.NetworkList = Response.Result;
        this.rerender();
      }, (error) => {
        if (error.status == 401 || error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
    }

    DeleteNetwork(NE_Id: number) {
      Swal.fire({
        position: 'top-end',
        title: 'Do You Want To Delete',
        text: 'If Deleted, Data can not be reverted back!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.userService.DeleteNetwork(NE_Id).subscribe(
            (data: any) => {
              Swal.fire('Data Record Deleted Successfully..')
            }, (error) => {
              Swal.fire('Changes will be Discarded..')
            });
        }
      })
    }

      /*for Datatable*/
      ngAfterViewInit(): void {
        this.dtTrigger.next();
      }

      ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
      }

      rerender(): void {
        try {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
          });
         this.dtTrigger.next();
        } catch (err) {
          console.log(err);
        }
      }
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/network/networkgrid/networkgrid.component.ts